import localforage from '../utils/localforage';
import http from '../utils/api';
import moment from 'moment';


export async function getFerias() {    
    let periodo = await localforage.getItem('periodo');  
    return http.get('atividades-sisinfo/ferias', {       
        params: {
            dtInicio:  moment(periodo.inicio).subtract(1, 'months').format('YYYY-MM-DD'),
            dtFim:  moment(periodo.fim).add(1, 'months').format('YYYY-MM-DD'),
        }
    }).then( async ({data}) => {
        await localforage.setItem('ferias', data?.data ?? [])
    }).catch(async () => {
        await localforage.setItem('ferias', [])
    });
}